const HANDLED_ERRORS = [400, 401, 403, 422];
export const handleError = ({ setError }) => (error) => {
    if (typeof error.status !== "number" ||
        !HANDLED_ERRORS.includes(error.status)) {
        return;
    }
    const violations = error.data.violations;
    if (!violations) {
        // Login error has different shape
        const loginError = error.data.message;
        if (loginError) {
            setError("root.formError", { message: loginError });
        }
        return;
    }
    // Show last validation error of each field
    violations
        .slice() // Clone array to avoid TypeError: 0 is read-only
        .reverse()
        .forEach(({ propertyPath, title }) => {
        if (propertyPath === "") {
            setError("root.formError", { message: title });
            return;
        }
        setError(propertyPath, { message: title });
    });
};
